<template>
  <MultiSelect
    class="SelectArticle"
    :fieldLabel="label"
    :internalSearch="false"
    label="topic"
    :loading="isLoading"
    :multiple="false"
    :options="articles"
    :searchable="true"
    trackBy="id"
    :value="article"
    @search-change="setFilter"
    @update:value="setArticle">
    <template #option="{ option }">
      <OptionArticle :article="option" />
    </template>
  </MultiSelect>
</template>

<script>
import { actions, getters } from '@utils'
import { propEq, propOr } from 'rambda'
import MultiSelect from '@components/fields/MultiSelect'
import OptionArticle from './OptionArticle'
import { debounce } from '@utils/async'

export default {
  components: {
    MultiSelect,
    OptionArticle,
  },
  props: {
    articleIdExcluded: Number,
    label: String,
    siteId: Number,
    value: null,
  },
  data() {
    return {
      isLoading: false,
      filter: '',
    }
  },
  computed: {
    articleQuery() {
      return {
        siteId: this.siteId,
        $or: [
          { topic: { $ilike: this.filter } },
        ],
      }
    },
    article() {
      return this.articles
        .find(propEq('id', this.value))
    },
    articles() {
      return this
        .query('article', this.articleQuery)
        .filter(({ id }) => id !== this.articleIdExcluded)
    },
    fetchArticlesDebounced() {
      return debounce(1000, this.FETCH_ARTICLE)
    },
    ...getters(),
  },
  methods: {
    setArticle(article) {
      const articleId = propOr(null, 'id', article)

      this.$up('value', articleId)
    },
    setFilter(filter) {
      this.filter = filter
    },
    fetchArticles(projectQuery) {
      return this.$wrap(
        () => this.fetchArticlesDebounced(projectQuery),
        'isLoading',
      )
    },
    ...actions('FETCH_ARTICLE'),
  },
  watch: {
    filter() {
      if (!this.filter || this.filter.length < 3) return

      return this.fetchArticles(this.articleQuery)
    },
  },
}
</script>

<style lang="scss">
.SelectArticle {
  &.ib {
    display: inline-block;

    .multiselect__tags {
      padding-right: 2rem;
    }
  }
}
</style>
